import { useMemo } from 'react'
import { Autocomplete, Checkbox, TextField } from '@mui/material'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

import { messages } from '../../utils/messages/index'
import { useRefData } from '../../hooks/data/useRefData'

const checkedIcon = <CheckBoxIcon fontSize="small" />
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />

const AutocompleteFilter = ({ filter, readOnly, onChange }) => {
  const { data: refData } = useRefData(filter.refDataKey)
  const options = useMemo(
    () =>
      (refData ?? []).map(row => ({
        id: row.id,
        name: filter.name,
        label: row[messages.getLangKey()],
      })),
    [refData, filter.name],
  )

  return (
    <Autocomplete
      disableCloseOnSelect
      multiple
      disabled={readOnly}
      getOptionLabel={option => option.label}
      id={filter.name}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id
      }}
      limitTags={3}
      options={options}
      renderInput={params => (
        <TextField {...params} label={filter.label} placeholder={filter.placeholder} />
      )}
      renderOption={(props, option, { selected }) => (
        <li key={`${filter.name}-af-${option.id}`} {...props}>
          <Checkbox
            checked={selected}
            checkedIcon={checkedIcon}
            icon={icon}
            size="small"
            style={{ marginRight: 8 }}
          />
          {option.label}
        </li>
      )}
      onChange={(event, value) => {
        onChange(value)
      }}
    />
  )
}

export default AutocompleteFilter
